import React from "react";
import "./footer.styles.scss";


const Footer = () => {

    return (
       <>
       <div className="space-section">

       </div>
       <div className="footer-container">
            <div className="footer-links-container">
            <a href="https://www.linkedin.com/in/visconttig/" target="_blank" rel="noopener noreferrer">Linkedin</a>
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/visconttig">GitHub</a>
            </div>
            <div id="attributions">
            <span>Icons by: --- </span>
            <span>Contact image by: --- </span>
            </div>
        </div>
       </>
    );
}



export default Footer;